import { Box, useTheme } from "@mui/material"
import { IPageLayoutProps } from "layouts/interface"
import { Outlet } from "react-router-dom"

export const PageLayout: React.FC<IPageLayoutProps> = ({
  children,
  header = null,
  footer = null,
  ...props
}) => {
  const theme = useTheme()
  const styleOverrides = theme.components[`AppPageLayout`]?.styleOverrides || {}
  const { root } = styleOverrides

  return (
    <Box sx={root} {...props} data-name="PageLayout">
      <Outlet />
    </Box>
  )
}
